import { render, staticRenderFns } from "./supportTiger.vue?vue&type=template&id=39c06b4a"
import script from "./supportTiger.vue?vue&type=script&lang=js"
export * from "./supportTiger.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/support-tiger.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports